import { PERIOD_OPTIONS, SCOPE_OPTIONS } from "../model/constants"
import type { LeaderboardPeriod, LeaderboardScope } from "../model/types"

export const isLeaderboardPeriod = (value: string | null | undefined): value is LeaderboardPeriod =>
  PERIOD_OPTIONS.some(option => option.value === value)

export const isLeaderboardScope = (value: string | null | undefined): value is LeaderboardScope =>
  SCOPE_OPTIONS.some(option => option.value === value)
